import { FormattedMessage } from "react-intl";
import type { CompanyFilters } from "@/lib/search-filters";
import {
  COMPANY_FIELDS,
  COMPANY_FREQUENT_FIELD_KEYS,
  isFieldActive,
  type OptionsByKey,
} from "@/lib/filter-fields";
import { FilterBuilder } from "./FilterBuilder";

// The Companies category. Same pill UI as Teamplayer (FilterBuilder), different field list — see
// @/lib/filter-fields COMPANY_FIELDS for which facets exist and, more importantly, which do not.

export function CompanyFilterBuilder({
  company,
  setCompany,
  optionsByKey,
  onEnter,
  compact = false,
}: {
  company: CompanyFilters;
  setCompany: React.Dispatch<React.SetStateAction<CompanyFilters>>;
  optionsByKey: OptionsByKey;
  onEnter?: () => void;
  compact?: boolean;
}) {
  const activeCount = COMPANY_FIELDS.filter((f) => isFieldActive(f, company)).length;
  return (
    <FilterBuilder
      fields={COMPANY_FIELDS}
      frequentKeys={COMPANY_FREQUENT_FIELD_KEYS}
      heading={
        <FormattedMessage
          id="companyFilter.heading"
          defaultMessage="Company filters{count, plural, =0 {} other { · # active}}"
          values={{ count: activeCount }}
        />
      }
      value={company}
      setValue={setCompany}
      optionsByKey={optionsByKey}
      onEnter={onEnter}
      compact={compact}
    />
  );
}
